import { CommonApiService } from 'src/app/API/commonapi.service.';
import { Component, ViewChild } from '@angular/core';
import { ContactApiService } from '../API/contactapi.service';
import { TableHeadsService } from '../Core/tableheads.service';
import { Router } from '@angular/router';
import { PageHeaderComponent } from '../Core/pageheader.component';
import { AppComponent } from '../app.component';
import { AuthService } from '../API/auth.service';

@Component({
  selector: 'ContactSearch',
  templateUrl: './ContactSearch.component.html',
})
export class ContactSearchComponent {

  constructor(
    private commonapi: CommonApiService,
    private contactapi: ContactApiService,
    private router: Router,
    private dataGridService: TableHeadsService,
    private auth: AuthService
  ) {
    this.page.pageNumber = 0;
    this.page.size = this.pageSize;
    this.setPage();
  }

  @ViewChild(PageHeaderComponent, { static: true }) pageheader: PageHeaderComponent;
  @ViewChild('excelInput') excelInput!: HTMLInputElement;
  alphaBetsList = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'];
  loading = true;
  GivenName = '';
  UserName = '';
  FamilyName = '';
  ContactTypeList = [];
  DivisionList = [];
  DesignationList = [];
  StatusList = [];
  Status = '';
  ContactType = '';
  Division = '';
  Designation = '';
  ContactId = '';
  prefixAlphabet = '';
  blnDirtySearch = false;
  tableHeaders;
  page = new Page();
  rows;
  AddUrl = '/Contact/ContactDetail';
  currentPageNumber = 1;
  sortExpression = 'givenName';
  sortDirection = 'ASC';
  pageSize = 100000;
  ShowSearch = false;
  title = 'Contact';
  searchText = 'Search Records';
  defaultSort;
  blnshowAddNew = false;
  userDesignation = this.auth.GetDesignationName();
  isAdminPermissionLoggedInUser = this.auth.GetIsAdminPermission();

  // (kept if you use a separate modal locally, but header now owns the popup)
  showImportModal = false;
  showImportVendor = false;
  selectedExcelFile: File | null = null;
  validRows: any[] = [];
  invalidRows: any[] = [];
  invalidEmailRows: any[] = [];
  duplicateInExcel: any[] = [];
  duplicateInDatabase: any[] = [];
  isValidating = false;
  isCommitting = false;
  validationDone = false; // to toggle results area
  ngOnInit() {
    // enable header actions here
    if (this.pageheader) {
      this.pageheader.showImportContact = true;
      this.pageheader.showDownloadTemplate = true;
    }
    
    this.SetPageRights();
    this.auth.GetCurrentUserDivision().subscribe(division => {
      this.dataGridService.clearHeader();
      this.dataGridService.addHeader('#', 'id', '4');
      this.dataGridService.addHeader('Name / Business Name', 'givenname', '25');
      this.dataGridService.addHeader('E-mail', 'emailaddress', '27');
      this.dataGridService.addHeader('Phone', 'cellphone', '14');
      this.dataGridService.addHeader('Contact Type', 'contacttype', '12');
      this.dataGridService.addHeader('Designation', 'designation', '10');
      this.dataGridService.addHeader('Status', 'status', '8');
      this.tableHeaders = this.dataGridService.setTableHeaders();
      this.defaultSort = this.dataGridService.setDefaultSort('givenname', false);
      this.fillStatus();
      this.fillContactTypeList();

      if (division.length === 1)
        this.fillDivisionList(division[0]);
      else
        this.fillDivisionList();

      this.fillDesignationList();
      this.CheckDirtySearch();
    }, error => {
      AppComponent.addAlert(error.message, 'error');
      AppComponent.HideLoader();
    });
  }

  // === Header event handlers ===============================================

  // Bound in template on header: (downloadTemplateClick)="onDownloadTemplate()"
  onDownloadTemplate() {
    AppComponent.ShowLoader();
    this.contactapi.DownloadTemplate().subscribe({
      next: (blob: Blob) => {
        // trigger browser download
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url; a.download = 'ContactsTemplate.xlsx'; a.click();
        URL.revokeObjectURL(url);
        AppComponent.HideLoader();
        AppComponent.addAlert('Template downloaded.', 'success');
      },
      error: (err) => {
        AppComponent.HideLoader();
        AppComponent.addAlert(err?.message || 'Failed to download template', 'error');
      }
    });
  }
openImportModal() {
  this.showImportModal = true;
  setTimeout(() => this.resetFileInput());
  this.selectedExcelFile = null;
  this.validRows = [];
  this.invalidRows = [];
  this.invalidEmailRows = [];
  this.duplicateInExcel = [];
  this.duplicateInDatabase = [];
  this.isValidating = false;
  this.isCommitting = false;
  this.validationDone = false;
}

closeImportModal() {
  // close only when user clicks close, or after a successful commit
  this.showImportModal = false;
}

onExcelFileChange(evt: Event) {
  
  const input = evt.target as HTMLInputElement;
  this.selectedExcelFile = (input?.files && input.files.length > 0) ? input.files[0] : null;
  this.validationDone = false;
  this.validRows = [];
  this.invalidRows = [];
  this.invalidEmailRows = [];
  this.duplicateInExcel = [];
  this.duplicateInDatabase = [];
  this.validateExcelInModal();
}

validateExcelInModal() {
  if (!this.selectedExcelFile) return;

  const fd = new FormData();
  fd.append('file', this.selectedExcelFile);

  this.isValidating = true;
  this.contactapi.ValidateImport(fd).subscribe({
    next: (res: any) => {
      this.isValidating = false;
      this.validationDone = true;

      this.validRows = res?.validRows || [];
      this.invalidRows = res?.invalidRows || [];
      this.duplicateInExcel = res?.duplicateInExcel || [];
      this.duplicateInDatabase = res?.duplicateInDatabase || [];

      // pick rows with email-specific issues (message includes “email” or email missing)
      this.invalidEmailRows = this.invalidRows.filter((r: any) =>
        (r?.errors || []).some((e: string) => /email/i.test(e)) || !r?.email
      );
      this.resetFileInput(); 
      // keep the modal open regardless of invalids — user will fix and re-upload
      
    },
    error: (err) => {
      this.isValidating = false;
      AppComponent.addAlert(err?.message || 'Validation failed', 'error');
    }
  });
}

confirmImportExcel() {
  AppComponent.ShowLoader();
  // do not allow import if any invalid rows exist
  if (this.invalidRows.length > 0) {
    AppComponent.addAlert('Please fix invalid rows and re-upload before importing.', 'warning');
    return;
  }

  // build allExcelEmails (for emailing everyone in the sheet, optional)
  const allExcelEmails: string[] = [];
  this.validRows.forEach((r: any) => r?.email && allExcelEmails.push(r.email));
  this.duplicateInExcel.forEach((r: any) => r?.email && allExcelEmails.push(r.email));
  this.duplicateInDatabase.forEach((r: any) => r?.email && allExcelEmails.push(r.email));

  let proceedSkippingDuplicates = true;
  const hasDuplicates = (this.duplicateInExcel.length + this.duplicateInDatabase.length) > 0;
  if (hasDuplicates) {
    proceedSkippingDuplicates = confirm(
      `Duplicates detected (Excel: ${this.duplicateInExcel.length}, Database: ${this.duplicateInDatabase.length}).\nProceed by importing only unique rows?`
    );
  }
  if (!proceedSkippingDuplicates) return;

  this.isCommitting = true;
  this.contactapi.CommitImport({
    rowsToImport: this.validRows,
    proceedSkippingDuplicates,
    emailAllFromExcel: true,
    allExcelEmails
  }).subscribe({
    next: (resp: any) => {
      this.isCommitting = false;
      const inserted = resp?.Inserted ?? resp?.inserted ?? 0;
      const skipped  = resp?.SkippedDuplicates ?? resp?.skippedDuplicates ?? 0;
      AppComponent.addAlert(`Imported: ${inserted}. Skipped duplicates: ${skipped}.`, 'success');
      this.executeContactSearch();
      this.closeImportModal(); // close only after success
      AppComponent.HideLoader();
    },
    error: (err) => {
      AppComponent.HideLoader();
      this.isCommitting = false;
      AppComponent.addAlert(err?.message || 'Import failed', 'error');
      
      // keep modal open so user can retry or download errors
    }
  });
}

confirmImportVendorExcel() {
      AppComponent.ShowLoader();
      // do not allow import if any invalid rows exist
      if (this.invalidRows.length > 0) {
        AppComponent.addAlert('Please fix invalid rows and re-upload before importing.', 'warning');
        return;
      }

      // build allExcelEmails (for emailing everyone in the sheet, optional)
      const allExcelEmails: string[] = [];
      this.validRows.forEach((r: any) => r?.mailingaddress && allExcelEmails.push(r.mailingaddress));
      this.duplicateInExcel.forEach((r: any) => r?.mailingaddress && allExcelEmails.push(r.mailingaddress));
      this.duplicateInDatabase.forEach((r: any) => r?.mailingaddress && allExcelEmails.push(r.mailingaddress));

      let proceedSkippingDuplicates = true;
      const hasDuplicates = (this.duplicateInExcel.length + this.duplicateInDatabase.length) > 0;
      if (hasDuplicates) {
        proceedSkippingDuplicates = confirm(
          `Duplicates detected (Excel: ${this.duplicateInExcel.length}, Database: ${this.duplicateInDatabase.length}).\nProceed by importing only unique rows?`
        );
      }
      if (!proceedSkippingDuplicates) return;

      this.isCommitting = true;
      this.contactapi.SaveVendor({
        rowsToImport: this.validRows,
        proceedSkippingDuplicates,
        emailAllFromExcel: true,
        allExcelEmails
      }).subscribe({
        next: (resp: any) => {
          this.isCommitting = false;
          const inserted = resp?.Inserted ?? resp?.inserted ?? 0;
          const skipped  = resp?.SkippedDuplicates ?? resp?.skippedDuplicates ?? 0;
          AppComponent.addAlert(`Imported: ${inserted}. Skipped duplicates: ${skipped}.`, 'success');
          this.executeContactSearch();
          this.closeVendorModal(); // close only after success
          AppComponent.HideLoader();
        },
        error: (err) => {
          AppComponent.HideLoader();
          this.isCommitting = false;
          AppComponent.addAlert(err?.message || 'Import failed', 'error');
          
          // keep modal open so user can retry or download errors
        }
      });
}
  // === Existing logic =======================================================

  SetPageRights() {
    if (
      this.userDesignation == 'Administrator' || this.userDesignation == 'Technologist' ||
      this.userDesignation == 'Senior Technologist' || this.userDesignation == 'Admin-Technologist' ||
      this.isAdminPermissionLoggedInUser
    ) {
      this.blnshowAddNew = true;
    }
  }

  onSearchShowChange(value) {
    this.ShowSearch = value;
  }

resetFileInput() {
  if (this.excelInput) this.excelInput.value = '';
}

  changeSorting(column) {
    if (column === '#') return;
    this.dataGridService.changeSorting(column, this.defaultSort, this.tableHeaders);
    this.defaultSort = this.dataGridService.getSort();
    this.sortDirection = this.dataGridService.getSortDirection();
    this.sortExpression = this.dataGridService.getSortExpression();
    this.currentPageNumber = 1;
    this.page.pageNumber = 1;
    this.executeContactSearch();
  }

  setSortIndicator = (column) => this.dataGridService.setSortIndicator(column, this.defaultSort);

  executeContactSearch() {
    AppComponent.ShowLoader();

    if (this.pageheader) {
      this.pageheader.isSearchOpen = false;
      this.pageheader.searchText = 'Search Records';
    }

    this.ShowSearch = false;
    this.searchText = 'Search Records';
    this.CheckDirtySearch();

    const contanctsearch = this.prepareSearch();
    this.contactapi.GetContactDetails(contanctsearch).subscribe(
      pagedData => {
        this.page.totalElements = pagedData.totalRows;
        this.page.totalPages = pagedData.totalPages;
        this.rows = pagedData.contactssearchDetails;

        if (pagedData.contactssearchDetails.designation == 'Technologist'
          || pagedData.contactssearchDetails.designation == 'Senior Technologist'
          || pagedData.contactssearchDetails.designation == 'Administrator'
          || pagedData.contactssearchDetails.designation == 'Admin-Technologist') {
          this.blnshowAddNew = true;
        }

        AppComponent.HideLoader();
      },
      error => {
        AppComponent.addAlert(error.message, 'error');
        AppComponent.HideLoader();
      }
    );
  }

  prepareSearch() {
    let contactsearch: any = {};
    contactsearch.ContactId = this.ContactId;
    contactsearch.name = this.GivenName;

    if (this.Division) contactsearch.divisionId = this.Division;
    if (this.Designation) contactsearch.designationId = this.Designation;
    if (this.ContactType) contactsearch.userType = this.ContactType;
    if (this.Status) contactsearch.status = this.Status;
    if (this.prefixAlphabet) contactsearch.alphabetPrefix = this.prefixAlphabet;

    contactsearch.contactInfo = this.ContactId;
    contactsearch.familyName = this.FamilyName;
    contactsearch.username = this.UserName;

    contactsearch.currentPageNumber = this.currentPageNumber;
    contactsearch.sortExpression = this.sortExpression;
    contactsearch.sortDirection = this.sortDirection;
    contactsearch.PageSize = this.pageSize;
    return contactsearch;
  }

  setPage() {
    this.currentPageNumber = (this.page && this.page.pageNumber) ? this.page.pageNumber : 1;
    this.executeContactSearch();
  }

  _onRowClick(row) {
    this.router.navigate(['Contact/ContactDetail'], { queryParams: { id: row } });
  }

  fillDivisionList(defaultValue = '') {
    this.commonapi.FillDivision(true).subscribe(list => {
      this.DivisionList = list;
      if (defaultValue) {
        this.Division = defaultValue;
        setTimeout(() => this.executeContactSearch());
      }
    });
  }

  fillContactTypeList() {
    this.contactapi.FillUserType().subscribe(list => this.ContactTypeList = list);
  }

  fillDesignationList() {
    this.contactapi.FillDesignation().subscribe(list => this.DesignationList = list);
  }

  fillStatus() {
    this.StatusList = [
      { value: '', text: 'Select' },
      { value: 'Active', text: 'Active' },
      { value: 'Inactive', text: 'Inactive' },
      { value: 'Pending', text: 'Pending' },
    ];
  }

  executeContactSearchClear() {
    this.GivenName = '';
    this.FamilyName = '';
    this.ContactId = '';
    this.Status = '';
    this.ContactType = '';
    this.Division = '';
    this.Designation = '';
    this.UserName = '';
    this.executeContactSearch();
  }

  alphabetChange(alphabet) {
    this.prefixAlphabet = alphabet;
    this.executeContactSearch();
  }

  clearAlphabet() {
    this.prefixAlphabet = '';
    this.executeContactSearch();
  }

  CheckDirtySearch() {
    this.blnDirtySearch = !!(
      this.GivenName !== '' ||
      this.FamilyName !== '' ||
      this.ContactId !== '' ||
      this.Status !== '' ||
      this.ContactType !== '' ||
      this.Division !== '' ||
      this.Designation !== '' ||
      this.UserName !== ''
    );
    return this.blnDirtySearch;
  }

  DialysisUnitDropDownChanged() {
    this.executeContactSearch();
  }

  hideSearch() {
     this.ShowSearch = false;
  }

  openVendorModal() {
    this.showImportVendor = true;
    setTimeout(() => this.resetFileInput());
    this.selectedExcelFile = null;
    this.validRows = [];
    this.invalidRows = [];
    this.invalidEmailRows = [];
    this.duplicateInExcel = [];
    this.duplicateInDatabase = [];
    this.isValidating = false;
    this.isCommitting = false;
    this.validationDone = false;
  }

  closeVendorModal() {
    this.showImportVendor = false;
  }

   onVendorDownloadTemplate() {
    AppComponent.ShowLoader();
    this.contactapi.VendorDownloadTemplate().subscribe({
      next: (blob: Blob) => {
        // trigger browser download
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url; a.download = 'VendorTemplate.xlsx'; a.click();
        URL.revokeObjectURL(url);
        AppComponent.HideLoader();
        AppComponent.addAlert('Template downloaded.', 'success');
      },
      error: (err) => {
        AppComponent.HideLoader();
        AppComponent.addAlert(err?.message || 'Failed to download template', 'error');
      }
    });
  }

  onVendorFileChange(evt: Event) {
    const input = evt.target as HTMLInputElement;
    this.selectedExcelFile = (input?.files && input.files.length > 0) ? input.files[0] : null;
    this.validationDone = false;
    this.validRows = [];
    this.invalidRows = [];
    this.invalidEmailRows = [];
    this.duplicateInExcel = [];
    this.duplicateInDatabase = [];
    this.validateVendorInModal();
  }

  validateVendorInModal() {
    if (!this.selectedExcelFile) return;

    const fd = new FormData();
    fd.append('file', this.selectedExcelFile);

    this.isValidating = true;
    this.contactapi.ValidateVendorImport(fd).subscribe({
      next: (res: any) => {
        this.isValidating = false;
        this.validationDone = true;

        this.validRows = res?.validRows || [];
        this.invalidRows = res?.invalidRows || [];
        this.duplicateInExcel = res?.duplicateInExcel || [];
        this.duplicateInDatabase = res?.duplicateInDatabase || [];

        // pick rows with email-specific issues (message includes “email” or email missing)
        this.invalidEmailRows = this.invalidRows.filter((r: any) =>
          (r?.errors || []).some((e: string) => /email/i.test(e)) || !r?.email
        );
        this.resetFileInput(); 
        // keep the modal open regardless of invalids — user will fix and re-upload
        
      },
      error: (err) => {
        this.isValidating = false;
        AppComponent.addAlert(err?.message || 'Validation failed', 'error');
      }
    });
  }
}

export class Page {
  size: number = 0;
  totalElements: number = 0;
  totalPages: number = 0;
  pageNumber: number = 0;
}
